import admin from "./admin";
import breadcrumb from "./breadcrumb";
import broker from "./broker";

const translations = { ...broker, ...admin, breadcrumb };

export default translations;
